module.exports = __webpack_public_path__ + "static/imageThree@2x-d9b5b6393d473fe5df5c06be07218f07.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/handoff/imageThree@2x.png
// module id = 2606
// module chunks = 168707334958949